import { Component, ElementRef, signal, ChangeDetectionStrategy, input, output, viewChild } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { CdkDrag, CdkDragEnd, CdkDragMove } from '@angular/cdk/drag-drop';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
	selector: 'ara-drag-to-complete',
	imports: [MatIconModule, CdkDrag, TranslocoModule],
	templateUrl: './drag-to-complete.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./drag-to-complete.component.scss'],
})
export class DragToCompleteComponent {
	readonly disabled = input(false);
	readonly label = input('');

	readonly completed = output<void>();

	readonly track = viewChild.required<ElementRef<HTMLDivElement>>('track');

	dragPosition = { x: 0, y: 0 };
	progress = signal(0);
	completedTriggered = false;

	onDragMoved(event: CdkDragMove) {
		if (this.disabled()) return;

		const trackRect = this.track().nativeElement.getBoundingClientRect();
		const handleWidth = event.source.element.nativeElement.offsetWidth;

		const leftGap = 4;

		const relativeX = event.pointerPosition.x - trackRect.left - leftGap;

		const maxDrag = trackRect.width - handleWidth - leftGap;

		const clamped = Math.min(Math.max(relativeX, 0), maxDrag);

		const percentage = (clamped / maxDrag) * 100;
		this.progress.set(percentage);
	}

	onDragEnded(_: CdkDragEnd) {
		if (this.disabled()) {
			this.reset();
			return;
		}
		if (this.progress() >= 100 && !this.completedTriggered) {
			this.completedTriggered = true;
			setTimeout(() => this.completed.emit(), 0);
			setTimeout(() => this.reset(), 500);
			return;
		}

		this.reset();
	}

	reset() {
		this.dragPosition = { x: 0, y: 0 };
		this.progress.set(0);
		this.completedTriggered = false;
	}
}
